import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FHEContainer } from 'data/components';
import { tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import FormUserManager from './Form/FormUserManager';
import { addUserManager } from '../../data/UsersManagers/actions';

class CraftsmanAdd extends PureComponent {
    static propTypes = {
        addUserManager: PropTypes.func.isRequired
    };

    addUserManager = data => {
        const { addUserManager } = this.props;
        return addUserManager(data);
    };
    render() {
        return (
            <FHEContainer withBackIcon>
                <FormUserManager type="add" sendDataFunc={this.addUserManager} />
            </FHEContainer>
        );
    }
}

export default renderEnvComponent(
    'scenes/UserManagers/add',
    connect(
        null,
        (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addUserManager }), dispatch)
    )(CraftsmanAdd)
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/UserManager/add.js